(function () {
  var DISMISS_KEY = 'lsd_free_gift_dismissed'; // user removed the gift → don't re-add this session
  var AUTO_KEY = 'lsd_free_gift_auto';         // we added the gift (manual or auto)
  var REMOVED_KEY = 'lsd_free_gift_removed_signed_out'; // we removed it on session loss → explain why

  // Show the "removed because you're signed out" note when we have just taken a gift out
  // of someone's basket. Until #204 the note REPLACED a sign-in line (`[data-fg-status]`);
  // #204 removed that line, so the note now simply appears, and the `[data-fg-status]`
  // lookup below finds nothing and is kept only as a guarded no-op (`if (status)`).
  // Runs after the section re-renders, so it is called from the cart:update path
  // rather than inline with the removal. If the note is not in the DOM yet the flag is
  // deliberately LEFT SET so the next render picks it up; it is cleared only once the
  // message has actually been shown, so the customer sees it exactly once.
  function applyRemovedNote() {
    var flagged = false;
    try { flagged = sessionStorage.getItem(REMOVED_KEY) === '1'; } catch (e) {}
    if (!flagged) return;
    var note = document.querySelector('[data-fg-removed-note]');
    if (!note) return;
    var status = document.querySelector('[data-fg-status]');
    if (status) status.hidden = true;
    note.hidden = false;
    try { sessionStorage.removeItem(REMOVED_KEY); } catch (e) {}
  }

  function giftVariantId() {
    var el = document.querySelector('[data-fg-variant]');
    var id = el && parseInt(el.getAttribute('data-fg-variant'), 10);
    return id || 58288350953846; // keep in step with cart-products.liquid
  }

  function getSectionIds() {
    var ids = new Set();
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id) ids.add(id);
    });
    return Array.from(ids).join(',');
  }

  // The count the header badge should SHOW: the cart's own count minus Advanced Shipping
  // Protection, which is a charge rather than something the customer put in their basket
  // and is hidden from the cart's product list. Returns null when the input carries no
  // count, so an endpoint response can be passed straight in.
  //
  // FALLBACK ONLY, and the reference is elsewhere. snippets/cart-display-count.liquid
  // defines the rule; countFromSections() below reads that snippet's RENDERED OUTPUT and
  // is the primary path. This function only runs when no returned section carries the
  // count. So editing cart-display-count.liquid does NOT require a matching edit here —
  // that is the point of parsing the span rather than reimplementing the rule.
  //
  // #73 MADE IT EQUIVALENT TO THE LIQUID, which it previously was not. The old version
  // matched a hardcoded handle and so subtracted whenever protection was in the cart,
  // including when the Liquid did not — the Liquid gates on `product.available` and
  // /cart.js line items carry no availability field. Reading the variant id off the
  // rendered component solves both: the id survives a rename, and the component is only in
  // the DOM when the product resolved AND was available, which is exactly when the Liquid
  // subtracts. No component, no attribute, no subtraction — same as the server.
  //
  // Prefer countFromSections wherever sections are in hand regardless; it reads the
  // server's own answer instead of reproducing the rule.
  function spVariantId() {
    var el = document.querySelector('[data-shipping-protection]');
    return (el && parseInt(el.getAttribute('data-sp-variant'), 10)) || 0;
  }

  function displayCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return null;
    var sp = spVariantId();
    var n = cart.item_count;
    (cart.items || []).forEach(function (i) {
      if (sp && i.variant_id === sp) n -= i.quantity || 0;
    });
    return n < 0 ? 0 : n;
  }

  // Always pass a number (#60). cart-icon.js USED to read
  // `event.detail.data?.itemCount ?? 0`, so dispatching without it silently set the header
  // badge to ZERO over a basket that still had items in it — that was #60. As of #150 it
  // ignores a non-numeric itemCount and leaves the badge alone, so an omission is no longer
  // destructive. It is still not free: cart-drawer.liquid's analytics listener guards on
  // `typeof newCount !== 'number'` and DROPS the event, so free-gift claims and removals
  // would report nothing at all. This function has a count in every path, so pass it —
  // omitting is the sanctioned fallback only for a producer that genuinely cannot read one.
  function broadcastUpdate(sections, source, itemCount) {
    var data = { sections: sections || {}, source: source || 'cart-free-gift' };
    if (typeof itemCount === 'number') data.itemCount = itemCount;
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: data } }));
  }

  // The count, taken from the SECTION HTML the endpoint just returned.
  //
  // cart-products.liquid renders the cart-display-count snippet into a hidden
  // `[ref="cartItemCount"]` span on every cart re-render, and component-cart-items.js
  // already reads that element the same way. Reusing it means three things:
  //
  //   1. It is SYNCHRONOUS. The obvious alternative on the claim path — /cart/add.js
  //      returns no `item_count`, so fetch /cart.js and broadcast after it — makes that
  //      read the only thing delivering `sections` to the DOM. A stalled read then stalls
  //      the cart re-render itself, so the button sits on 'ADDING…' and the basket looks
  //      unresponsive. That trades a wrong badge for a cart that appears broken.
  //   2. It is the SERVER's number, so it applies cart-display-count.liquid's
  //      `product.available` test, which JS cannot do — /cart.js line items carry no
  //      availability field.
  //   3. It needs no extra request.
  //
  // Falls back to displayCount(cart) when the span is absent. That happens when the cart
  // renders its EMPTY branch, where the fallback correctly yields 0, or if a section were
  // ever returned without the cart in it.
  function countFromSections(sections, cart) {
    try {
      for (var key in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, key)) continue;
        var el = new DOMParser()
          .parseFromString(sections[key], 'text/html')
          .querySelector('[ref="cartItemCount"]');
        if (!el) continue;
        var n = parseInt(String(el.textContent).trim(), 10);
        if (!isNaN(n)) return n < 0 ? 0 : n;
      }
    } catch (e) {}
    // Separate try, deliberately. Folding this into the one above would mean a DOMParser
    // failure skipped the fallback as well, turning a recoverable parse problem into no
    // count at all. And nothing may escape this function: a throw here would abort
    // argument evaluation, so broadcastUpdate would never be called — no cart:update, no
    // section morph, no badge update. Silence beats that.
    try {
      return displayCount(cart);
    } catch (e) {
      return null;
    }
  }

  function track(event, props) {
    try {
      if (window.lsdTrack) window.lsdTrack(event, props || {});
      else if (window.posthog && window.posthog.capture) window.posthog.capture(event, props || {});
    } catch (e) {}
  }

  var addInFlight = false;

  // ── Add logic. Only ever reached from the claim button's click handler. ──
  // isAuto is now always false — nothing adds the gift except the click handler. The
  // parameter and its 'free_gift_auto_added' event are kept so the analytics shape is
  // unchanged and restoring auto-add stays a one-line change.
  function addFreeGift(btn, isAuto) {
    if (!btn || addInFlight) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      track('free_gift_claim_skipped', { reason: 'no_variant_id' });
      return;
    }
    if (btn.getAttribute('aria-busy') === 'true') return;

    addInFlight = true;
    btn.setAttribute('aria-busy', 'true');
    var originalText = btn.textContent;
    btn.textContent = 'ADDING…';
    var startTime = Date.now();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { '_free_gift': 'true' } }],
        sections: getSectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { json: j, status: r.status, ok: r.ok }; }); })
      .then(function (resp) {
        var data = resp.json;
        var duration = Date.now() - startTime;
        if (!resp.ok || (data && data.status && data.status >= 400)) {
          track('free_gift_claim_failed', { http_status: resp.status, api_status: data && data.status, message: data && data.message, is_auto: !!isAuto, duration_ms: duration });
          btn.textContent = originalText;
          btn.removeAttribute('aria-busy');
          addInFlight = false;
          return;
        }
        track(isAuto ? 'free_gift_auto_added' : 'free_gift_claim_succeeded', { duration_ms: duration });
        try { sessionStorage.setItem(AUTO_KEY, '1'); } catch (e) {}
        addInFlight = false;
        broadcastUpdate(data.sections, 'cart-free-gift-claim', countFromSections(data.sections, data));
      })
      .catch(function (err) {
        track('free_gift_claim_error', { error_message: err && err.message, is_auto: !!isAuto });
        btn.textContent = originalText;
        btn.removeAttribute('aria-busy');
        addInFlight = false;
      });
  }

  // ── Manual claim (button still works as a fallback) ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-free-gift-claim]');
    if (!btn) return;
    e.preventDefault();
    track('free_gift_claim_tapped', {
      device_type: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    });
    addFreeGift(btn, false);
  });

  // ── Gift-only cart: the checkout gate ──
  //
  // Christian found the race, 2026-07-31: remove the last non-gift line and click Check out
  // fast enough and you reach checkout with nothing but the free £45-retail tote. The
  // reconcile below is DEBOUNCED (350ms) so the basket is briefly gift-only and reachable.
  // Reacting after the fact was the wrong shape for this — a debounce can always be beaten.
  //
  // This reads the DOM SYNCHRONOUSLY on the click instead. The theme re-renders the cart
  // section when a line is removed, so by the time the button can be clicked the markup
  // already shows the real basket — it is the reconcile that lags, not the DOM. No fetch,
  // no await, nothing to race.
  //
  // Counts DISTINCT data-key values, because the drawer and the cart page both render the
  // same lines and a naive row count would double them.
  //
  // FAILS OPEN BY DESIGN. If the markup is not what we expect, this returns false and
  // checkout proceeds exactly as it does today. A bug here must never block a real customer
  // from paying; the cost of the rare miss is one free tote, the cost of a false block is a
  // lost order.
  function cartIsGiftOnly() {
    try {
      var rows = document.querySelectorAll('tr[data-key]');
      if (!rows.length) return false;
      var allKeys = {}, giftKeys = {}, nAll = 0, nGift = 0;
      for (var i = 0; i < rows.length; i++) {
        var k = rows[i].getAttribute('data-key');
        if (!k) continue;
        if (!allKeys[k]) { allKeys[k] = 1; nAll++; }
        if (rows[i].querySelector('[data-free-gift-remove]') && !giftKeys[k]) { giftKeys[k] = 1; nGift++; }
      }
      return nAll === 1 && nGift === 1;
    } catch (e) {
      return false;
    }
  }

  // Capture phase, so this runs before the form's own submit handling.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('button[name="checkout"], #checkout');
    if (!el) return;
    if (!cartIsGiftOnly()) return;
    e.preventDefault();
    e.stopPropagation();
    track('free_gift_checkout_blocked', {});
    // Empty the gift out; the cart then renders empty and the theme disables checkout
    // itself — cart-summary.liquid disables checkout when `cart == empty or
    // cs_display_count == 0`. Cited without a line number on purpose (#49).
    var giftBtn = document.querySelector('[data-free-gift-remove]');
    var key = giftBtn && giftBtn.getAttribute('data-key');
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: getSectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.sections) {
          try { sessionStorage.removeItem(AUTO_KEY); } catch (err) {}
          broadcastUpdate(data.sections, 'cart-free-gift-auto-remove', countFromSections(data.sections, data));
        }
      })
      .catch(function () {});
  }, true);

  // ── Remove button on the gift line ──
  // The gift renders a Remove button rather than a quantity selector, so removal does not
  // go through the theme's quantity machinery at all. Setting DISMISS_KEY here means the
  // reconcile's dismissal branch does not also fire and double-report it.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-free-gift-remove]');
    if (!rm) return;
    e.preventDefault();
    if (rm.getAttribute('aria-busy') === 'true') return;
    var key = rm.getAttribute('data-key');
    if (!key) return;
    rm.setAttribute('aria-busy', 'true');
    var originalText = rm.textContent;
    rm.textContent = 'REMOVING…';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: getSectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.sections) {
          track('free_gift_removed_by_customer', {});
          try { sessionStorage.setItem(DISMISS_KEY, '1'); sessionStorage.removeItem(AUTO_KEY); } catch (err) {}
          broadcastUpdate(data.sections, 'cart-free-gift-auto-remove', countFromSections(data.sections, data));
        } else {
          rm.removeAttribute('aria-busy');
          rm.textContent = originalText;
        }
      })
      .catch(function () {
        rm.removeAttribute('aria-busy');
        rm.textContent = originalText;
      });
  });

  // ── Reconcile: orphan-remove, then dismissal-detect. Never adds. (race-safe, all after one /cart.js read) ──
  var reconcileInFlight = false;

  function reconcile() {
    if (reconcileInFlight || addInFlight) return;
    reconcileInFlight = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) { reconcileInFlight = false; return; }

        // Find the free-gift line we added
        var freeTote = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          // Match on VARIANT, not on the _free_gift property (#2). A gift added directly
          // from its product page carries no property, so a property match made every guard
          // below blind to exactly the route that bypasses the offer. The id comes from the
          // reconcile div the Liquid renders, with the literal as a fallback.
          if (it.variant_id === giftVariantId()) { freeTote = it; break; }
        }

        // Eligibility-based reconcile (#9, 2026-07-31). The gift is a £0 line item, and a £0 line
        // can't be detected as "no longer free" by price — so we read the eligibility flag that
        // cart-products.liquid renders instead of comparing the cart total to a threshold.
        // There is no cart-value test here any more: eligibility is decided entirely in Liquid
        // from customer.orders_count and the `tote-claimed` tag.
        var recEl = document.querySelector('[data-fg-eligible]');
        var eligible = recEl ? recEl.getAttribute('data-fg-eligible') === 'true' : false;
        var qualifies = eligible;

        // 1) Orphan: gift in cart but the shopper is no longer eligible (e.g. signed out
        //    mid-session) → remove.
        //
        //    GUARD ON recEl, NOT ON `!eligible` ALONE. If the element is missing — a render race,
        //    a section that hasn't swapped in yet — `eligible` is false, and an `if (freeTote &&
        //    !eligible)` would read "absent" as "ineligible" and silently strip a gift the customer
        //    legitimately earned. The old code guarded with !isNaN(threshold) for exactly this
        //    reason; recEl is that guard's replacement. Do not simplify it away.
        if (freeTote && recEl && !eligible) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: freeTote.key, quantity: 0, sections: getSectionIds(), sections_url: window.location.pathname })
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (data && data.sections) {
                track('free_gift_auto_removed', {});
                try { sessionStorage.setItem(REMOVED_KEY, '1'); } catch (e) {}
                broadcastUpdate(data.sections, 'cart-free-gift-auto-remove', countFromSections(data.sections, data));
                // The listener below ignores our own remove, so reveal the note here once
                // the re-rendered section has had a tick to land.
                setTimeout(applyRemovedNote, 250);
              }
            })
            .catch(function () {})
            .finally(function () { reconcileInFlight = false; });
          return;
        }

        var wasAdded = false;
        try { wasAdded = sessionStorage.getItem(AUTO_KEY) === '1'; } catch (e) {}

        // 1a) The gift cannot be the ONLY thing in the basket. Otherwise an eligible
        //     customer adds a product, claims the tote, removes the product, and checks
        //     out with a free £45-retail item and nothing else — a complete giveaway
        //     that needs no bypass at all, just the remove button.
        //
        //     Deliberately NOT guarded on recEl/eligible: this is a structural rule about
        //     what the basket may contain, not a question about who the shopper is, and
        //     cart.items comes from /cart.js which is authoritative. If freeTote is set
        //     and there is exactly one line, that line IS the gift.
        //
        //     No explanatory message: the basket ends up empty, which explains itself.
        if (freeTote && cart.items.length === 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: freeTote.key, quantity: 0, sections: getSectionIds(), sections_url: window.location.pathname })
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (data && data.sections) {
                track('free_gift_removed_last_item', {});
                try { sessionStorage.removeItem(AUTO_KEY); } catch (e) {}
                broadcastUpdate(data.sections, 'cart-free-gift-auto-remove', countFromSections(data.sections, data));
              }
            })
            .catch(function () {})
            .finally(function () { reconcileInFlight = false; });
          return;
        }

        // 1b) Quantity clamp. The cart UI disables the quantity control on the gift line,
        //     but that is a convention, not enforcement — /cart/change.js is a public endpoint
        //     and the line can be bumped directly. One free tote per cart, so anything above
        //     one is put back to one rather than removed outright: the customer keeps the gift
        //     they are entitled to and loses only the extras.
        if (freeTote && recEl && eligible && freeTote.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: freeTote.key, quantity: 1, sections: getSectionIds(), sections_url: window.location.pathname })
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (data && data.sections) {
                track('free_gift_quantity_clamped', { from: freeTote.quantity });
                broadcastUpdate(data.sections, 'cart-free-gift-auto-remove', countFromSections(data.sections, data));
              }
            })
            .catch(function () {})
            .finally(function () { reconcileInFlight = false; });
          return;
        }

        // 2) The shopper added the tote and has since taken it out. Record it and
        //    leave them alone — the offer re-renders on its own (it shows whenever
        //    the gift is not in the cart), so they can change their mind freely.
        if (wasAdded && !freeTote && qualifies) {
          try { sessionStorage.setItem(DISMISS_KEY, '1'); sessionStorage.removeItem(AUTO_KEY); } catch (e) {}
          track('free_gift_dismissed', {});
          reconcileInFlight = false;
          return;
        }

        // 3) NOTHING IS ADDED AUTOMATICALLY.
        //
        //    Christian, 2026-07-31, after seeing it on the preview: the tote appearing
        //    in the basket unasked read as an error rather than a gift — the offer card
        //    hides once the gift is in the cart, so the only thing he saw was an item he
        //    had not chosen. The card, with its "ADD MY FREE TOTE" button, IS the context;
        //    auto-adding was what removed it.
        //
        //    This reconcile now only ever REMOVES an orphaned gift (branch 1) and records
        //    a dismissal (branch 2). Adding happens solely from the click handler above.
        reconcileInFlight = false;
      })
      .catch(function () { reconcileInFlight = false; });
  }

  // Debounced reconcile: only runs once the cart has been STABLE for a beat, so we
  // never fire a /cart/add or /cart/change while the theme is mid-mutation (that race
  // could remove the wrong line / wipe the cart). Each new cart:update resets the timer.
  var reconcileTimer = null;
  function scheduleReconcile(delay) {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () { reconcileTimer = null; reconcile(); }, delay);
  }

  document.addEventListener('cart:update', function (e) {
    applyRemovedNote(); // a pending explanation survives until its element renders
    var source = e.detail && e.detail.data && e.detail.data.source;
    // Shrink the window rather than relying on the checkout gate alone: if the basket is
    // already visibly gift-only, clear it now instead of waiting out the debounce below.
    if (source !== 'cart-free-gift-auto-remove' && cartIsGiftOnly()) { scheduleReconcile(0); }
    if (source === 'cart-free-gift-auto-remove') return; // our own remove
    if (source === 'cart-free-gift-claim') return;        // our own add (gift just landed)
    scheduleReconcile(350); // wait for the cart to settle before touching it
  });

  document.addEventListener('DOMContentLoaded', function () { applyRemovedNote(); scheduleReconcile(200); });

  // #221: the drawer's SIGN IN (snippets/cart-products.liquid) is a Shopify sign-in link,
  // routes.storefront_login_url, whose return_to Shopify fills from the request that rendered
  // it. After a cart change the drawer is re-rendered as a section, so that request is a
  // header-only address (…?sections=…header_section, or …?section_id=…) and a shopper who
  // signs in from it lands on an unstyled page. Point every sign-in link at the page the
  // shopper is actually on, at the moment it is used: pointerdown (first touch or press,
  // before an iPhone long-press menu or a drag reads the link), click (mouse, tap and
  // Enter), auxclick (middle-click) and contextmenu (open in a new tab). return_to must be a
  // relative URL (Shopify's sign-in docs), and pathname + search always is. Shopify's other
  // parameters (locale, ui_hint, region_country) are left as they were.
  // A SIGN IN inside the cart drawer also adds lsd_cart=open, so the shopper comes back with
  // the drawer open (Christian, 30 Sep 2026); openCartAfterSignIn below reads it. A query
  // parameter rather than a # marker, because the theme gives # a meaning on Back (#168).
  var OPEN_CART_PARAM = 'lsd_cart';
  function fixSignInReturn(e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href*="/customer_authentication/login"]') : null;
    if (!link) return;
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var params = new URLSearchParams(window.location.search);
      params.delete(OPEN_CART_PARAM);
      if (link.closest('cart-drawer-component')) params.set(OPEN_CART_PARAM, 'open');
      var query = params.toString();
      var here = window.location.pathname + (query ? '?' + query : '');
      if (url.searchParams.get('return_to') === here) return;
      url.searchParams.set('return_to', here);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (err) { /* leave the link as Shopify built it */ }
  }
  ['pointerdown', 'click', 'auxclick', 'contextmenu'].forEach(function (type) {
    document.addEventListener(type, fixSignInReturn, true);
  });

  // #221: back from a SIGN IN that started in the cart drawer (lsd_cart=open, set above).
  // Take the marker out of the address first, keeping every other parameter (Shopify adds its
  // own after a sign-in), so a refresh, a shared link or Back never reopens the drawer; then
  // open it through cart-drawer.js's own open(). With no drawer on the page, nothing happens.
  function openCartAfterSignIn() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get(OPEN_CART_PARAM) !== 'open') return;
      params.delete(OPEN_CART_PARAM);
      var query = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
      if (!window.customElements) return;
      window.customElements.whenDefined('cart-drawer-component').then(function () {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
    } catch (err) { /* the page still works; the drawer just stays closed */ }
  }
  openCartAfterSignIn();
})();
